import React, { createContext, useContext, useState } from "react";

interface CategoryViewFilters {
  searchQuery: string;
  setSearchQuery: React.Dispatch<React.SetStateAction<string>>;
  matchWholeWords: boolean;
  setMatchWholeWords: React.Dispatch<React.SetStateAction<boolean>>;
}

const CategoryViewFiltersContext = createContext<CategoryViewFilters | null>(null);

export const CategoryViewFiltersProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [searchQuery, setSearchQuery] = useState("");
  const [matchWholeWords, setMatchWholeWords] = useState(false);

  return (
    <CategoryViewFiltersContext.Provider
      value={{ searchQuery, setSearchQuery, matchWholeWords, setMatchWholeWords }}
    >
      {children}
    </CategoryViewFiltersContext.Provider>
  );
};

export const useCategoryViewFilters = () => useContext(CategoryViewFiltersContext);
